// State
export const STATE_LAST_ERROR = "global/STATE_LAST_ERROR";
export const STATE_ERROR_LOG = "global/STATE_ERROR_LOG";
export const STATE_DEBUG_LOG = "global/STATE_DEBUG_LOG";
export const STATE_APP_BUSY_STATE = "global/STATE_APP_BUSY_STATE";
export const STATE_APP_FEEDBACK_STATE = "global/STATE_APP_FEEDBACK_STATE";
export const STATE_COMPONENT_BUSY_STATE = "global/STATE_COMPONENT_BUSY_STATE";
export const STATE_MODAL_IS_VISIBLE = "global/STATE_MODAL_IS_VISIBLE";
export const STATE_MODAL_PROFILEEDIT_IS_VISIBLE = "global/STATE_MODAL_PROFILEEDIT_IS_VISIBLE";

// Getters
export const GET_LAST_ERROR = "global/GET_LAST_ERROR";
export const GET_ERROR_LOG = "global/GET_ERROR_LOG";
export const GET_DEBUG_LOG = "global/GET_DEBUG_LOG";
export const GET_APP_BUSY_STATE = "global/GET_APP_BUSY_STATE";
export const GET_APP_FEEDBACK_STATE = "global/GET_APP_FEEDBACK_STATE";
export const GET_COMPONENT_BUSY_STATE = "global/GET_COMPONENT_BUSY_STATE";
export const GET_MODAL_IS_VISIBLE = "global/GET_MODAL_IS_VISIBLE";
export const GET_MODAL_PROFILEEDIT_IS_VISIBLE = "global/GET_MODAL_PROFILEEDIT_IS_VISIBLE";

// Mutations
export const MUTATE_ADD_ERRORLOG_ENTRY = "global/MUTATE_ADD_ERRORLOG_ENTRY";
export const MUTATE_ADD_DEBUGLOG_ENTRY = "global/MUTATE_ADD_DEBUGLOG_ENTRY";
export const MUTATE_SET_APP_BUSY_STATE = "global/MUTATE_SET_APP_BUSY_STATE";
export const MUTATE_SET_APP_FEEDBACK_STATE = "global/MUTATE_SET_APP_FEEDBACK_STATE";
export const MUTATE_SET_COMPONENT_BUSY_STATE = "global/MUTATE_SET_COMPONENT_BUSY_STATE";
export const MUTATE_SET_MODAL_VISIBILITY = "global/MUTATE_SET_MODAL_VISIBILITY";
export const MUTATE_SET_MODAL_PROFILEEDIT_VISIBILITY = "global/MUTATE_SET_MODAL_PROFILEEDIT_VISIBILITY";

// Actions
export const ACTION_ADD_ERRORLOG_ENTRY = "global/ACTION_ADD_ERRORLOG_ENTRY";
export const ACTION_ADD_DEBUGLOG_ENTRY = "global/ACTION_ADD_DEBUGLOG_ENTRY";
export const ACTION_SET_APP_BUSY_STATE = "global/ACTION_SET_APP_BUSY_STATE";
export const ACTION_SET_COMPONENT_BUSY_STATE = "global/ACTION_SET_COMPONENT_BUSY_STATE";
export const ACTION_SET_APP_AS_IDLE = "global/ACTION_SET_APP_AS_IDLE";
export const ACTION_SET_APP_AS_BUSY = "global/ACTION_SET_APP_AS_BUSY";
export const ACTION_SET_APP_AS_BUSYMODAL = "global/ACTION_SET_APP_AS_BUSYMODAL";
export const ACTION_SET_APP_FEEDBACK_STATE = "global/ACTION_SET_APP_FEEDBACK_STATE";
export const ACTION_SET_MODAL_VISIBILITY = "global/ACTION_SET_MODAL_VISIBILITY";
export const ACTION_SET_MODAL_PROFILEEDIT_VISIBILITY = "global/ACTION_SET_MODAL_PROFILEEDIT_VISIBILITY";
